import { useRef } from 'react';
import { Paperclip, ArrowSquareOut } from '@phosphor-icons/react';
import { Button } from 'src/v2/commonComponents/Button';
import { ReactTooltip } from 'src/v2/commonComponents/ReactTooltip';
import {
  useBreakpoint,
  useComparingConversationsParams,
  useGetUser,
  useOutsideClick,
  useVisible,
} from 'src/hooks';
import {
  NOT_AVAILABLE_IN_COMPARE_MODE,
  SUPER_PROJECT_NAME,
  SVG_SIZE_M,
  SVG_SIZE_S,
} from 'src/constants';
import { AddAttachmentButton } from 'src/v2/components/ThreadInputBox/components/AddAttachmentButton';
import { CapturePhoto } from 'src/components/CapturePhoto';
import styles from './MoreActionsButton.module.scss';
import { useRightSidePanelState, useRedirectToSNWithParams } from 'src/hooks';
import { useFeatureFlagEnabled } from 'posthog-js/react';

const MORE_ACTIONS_ANCHOR_ID = 'more-actions-input-trigger';

// TODO(olha): rename to AttachTool
const MoreActionsButton = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { isVisible, onVisibilityRemove, onVisibilityToggle } = useVisible();
  const { isImageEditSectionExpanded } = useRightSidePanelState();
  const { isCompareMode } = useComparingConversationsParams();
  const { isTabletAndUp } = useBreakpoint();
  const { href } = useRedirectToSNWithParams();
  const { isFreeTier, isStarterTier } = useGetUser();
  const disableRequestsInMNForFreeTier = useFeatureFlagEnabled(
    'disableRequestsInMNForFreeTier',
  );

  const handleOutsideClick = () => {
    onVisibilityRemove();
  };

  useOutsideClick(containerRef, handleOutsideClick);

  const handleClick = () => {
    onVisibilityRemove();
  };

  const tooltipContent = isCompareMode
    ? NOT_AVAILABLE_IN_COMPARE_MODE
    : isTabletAndUp
      ? 'Attach files'
      : undefined;

  return (
    <div id={MORE_ACTIONS_ANCHOR_ID} ref={containerRef} className={styles.root}>
      <Button
        shape="round"
        color="transparent"
        onClick={onVisibilityToggle}
        disabled={
          isImageEditSectionExpanded ||
          isCompareMode ||
          ((isFreeTier || isStarterTier) && disableRequestsInMNForFreeTier)
        }
        tooltipContent={tooltipContent}
      >
        <Paperclip size={SVG_SIZE_M} />
      </Button>

      <ReactTooltip
        place={isTabletAndUp ? 'top-start' : 'bottom-start'}
        id={MORE_ACTIONS_ANCHOR_ID}
        isOpen={isVisible}
        offset={isTabletAndUp ? -38 : 0}
        className={styles.tooltip}
      >
        <AddAttachmentButton withTitle onClose={onVisibilityRemove} />

        <CapturePhoto withTitle onClose={onVisibilityRemove} />
        <hr className="divider" />
        <div className={styles.SNWrapper}>
          <span>Large file? Need infinite context?</span>
          <Button
            href={href}
            as="a"
            target="_blank"
            rel="noopener noreferrer"
            color="secondary-outline"
            size="small"
            onClick={handleClick}
            className={styles.button}
          >
            Try {SUPER_PROJECT_NAME}
            <ArrowSquareOut size={SVG_SIZE_S} />
          </Button>
        </div>
      </ReactTooltip>
    </div>
  );
};

export default MoreActionsButton;
